import { useState, useMemo, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Card, Divider, Grid, IconButton, TextField, Typography } from '@mui/material';
import { ButtonBasic, SelectReportUser} from '../../components';
import DownloadFile from '../../services/downloadFile.service';
import AddIcon from '@mui/icons-material/Add';
import { showModal } from 'react-redux-modal-provider';
import ModalRepDownRangoFecha from './ModalRepDownRangoFecha';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FechaFunction from '../../function/FechaFunction';
import ConfirmationDialog from '../default/ConfirmationDialog';
import {toast} from 'react-toastify';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';

const ModalReporteProgramado = ({show, hideModal, item, reporteArr,onGuardar}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const [reporteSelect, setReporteSelect] = useState(null);
    const [reporteTipoSelect, setReporteTipoSelect] = useState(null);
    const [rangoFechasArray, setRangoFechasArray] = useState([]);
    const [tipoPrograma, setTipoPrograma] = useState('DIA');
    const [tipoProgramaData, setTipoProgramaData] = useState({
        diaLunes_lr: false,
        diaMartes_lr: false,
        diaMiercoles_lr: false,
        diaJueves_lr: false,
        diaViernes_lr: false,
        diaSabado_lr: false,
        diaDomingo_lr: false,
    });
    const [tipoProgramTime, setTipoProgramTime] = useState('12:00');
    const handleClose = () => hideModal();

    const onSubmit = async() => {
        if(tipoPrograma === 'DIA' &&
            ( !tipoProgramaData.diaLunes_lr &&
            !tipoProgramaData.diaMartes_lr &&
            !tipoProgramaData.diaMiercoles_lr &&
            !tipoProgramaData.diaJueves_lr &&
            !tipoProgramaData.diaViernes_lr &&
            !tipoProgramaData.diaSabado_lr &&
            !tipoProgramaData.diaDomingo_lr)
        ){
            toast.error('Debe seleccionar un día', {
                position: "top-right",
                autoClose: 2500,
                pauseOnHover: false,
            });
        }else{
            setIsLoading(true)
            const form = {
                reporteId_lr: reporteSelect,
                rangoFechasArray: rangoFechasArray,
                tipo_lr: tipoPrograma,
                horario_lr: `${tipoProgramTime}:00`,
                ...tipoProgramaData,
            };
            if(item?.id_lr){
                await DownloadFile.updateReportExcelNubiV2({...item,...form})
                .then(()=>{
                    if(onGuardar){
                        onGuardar()
                    }
                    handleClose()
                })
                .catch(()=>{
                    setIsLoading(false)
                })
                .finally(()=>{
                    setIsLoading(false)
                })
            }else{
                await DownloadFile.reportExcelNubiV2(form)
                .then(()=>{
                    if(onGuardar){
                        onGuardar()
                    }
                    handleClose()
                })
                .catch(()=>{
                    setIsLoading(false)
                })
                .finally(()=>{
                    setIsLoading(false)
                })
            }
        }
    };
    const onOpenModalRangoFecha = () => {
        showModal(ModalRepDownRangoFecha, { tipo: reporteTipoSelect,rangoFechasArray: rangoFechasArray, setRangoFechasArray: setRangoFechasArray })
    }
    const onEliminarValid = (idValid) =>{
        const validFilter = rangoFechasArray?.filter((ivd)=> ivd?.keyCampo !== idValid)
        setRangoFechasArray(validFilter)
    }
    const onOpenModalDeleteValid = (idValid) =>{
        showModal(ConfirmationDialog, {
            title: 'Eliminar el filtro',
            message: '¿Esta seguro que desea eliminar el filtro?',
            onConfirm: () => onEliminarValid(idValid)
        });
    }
    const onSelectTipoReport = (repJson) => {
        setReporteSelect(repJson?.value)
        if(repJson?.tipo_rts !== reporteTipoSelect){
            setRangoFechasArray([]);
            setReporteTipoSelect(repJson?.tipo_rts)
        }
    }
    const onSelectTipoProg = (tipo) =>{
        setTipoPrograma(tipo)
        if(tipo === 'NUMERO'){
            setTipoProgramaData({numero_lr: 1})
        }else{
            setTipoProgramaData({
                diaLunes_lr: false,
                diaMartes_lr: false,
                diaMiercoles_lr: false,
                diaJueves_lr: false,
                diaViernes_lr: false,
                diaSabado_lr: false,
                diaDomingo_lr: false,
            })
        }
    }
    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                borderColor: isDarkMode ? '#90caf9' : '#000',
                color: isDarkMode ? '#e0e0e0' : '#000',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#3d4a62' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    useEffect(() => {
        if(item){
            setTimeout(() => {
                setReporteSelect(item?.reporteId_lr)
                setReporteTipoSelect(item?.['report.tipo_rts'])
                setRangoFechasArray(JSON.parse(item?.rangoFecha_lr))
                setTipoPrograma(item?.tipo_lr)
                const timeNew = item?.horario_lr.split(':')
                setTipoProgramTime(`${timeNew[0]}:${timeNew[1]}`);
                setTipoProgramaData({
                    diaLunes_lr: item?.diaLunes_lr,
                    diaMartes_lr: item?.diaMartes_lr,
                    diaMiercoles_lr: item?.diaMiercoles_lr,
                    diaJueves_lr: item?.diaJueves_lr,
                    diaViernes_lr: item?.diaViernes_lr,
                    diaSabado_lr: item?.diaSabado_lr,
                    diaDomingo_lr: item?.diaDomingo_lr,
                    numero_lr: item?.numero_lr
                })
            }, 300);
        }
    }, [])

    const dias = [
        { key: 'diaLunes_lr', label: 'Lun' },
        { key: 'diaMartes_lr', label: 'Mar' },
        { key: 'diaMiercoles_lr', label: 'Mié' },
        { key: 'diaJueves_lr', label: 'Jue' },
        { key: 'diaViernes_lr', label: 'Vie' },
        { key: 'diaSabado_lr', label: 'Sáb' },
        { key: 'diaDomingo_lr', label: 'Dom' },
    ];

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(2px)'}}>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #0364ff 0%, #0284ff 100%)',
                            borderRadius: 1.5, p: 0.75,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(3, 100, 255, 0.25)'
                        }}>
                            <ScheduleIcon sx={{ color: '#fff', fontSize: 22 }} />
                        </Box>
                        <Box>
                            <Typography sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontWeight: 700, fontSize: '1.1rem', lineHeight: 1.2 }}>
                                {item?.id_lr ? 'Editar' : 'Nuevo'} Reporte Programado
                            </Typography>
                            <Typography sx={{ color: isDarkMode ? '#78909c' : '#94a3b8', fontSize: '0.72rem', fontWeight: 500, lineHeight: 1 }}>
                                Configure la programación automática
                            </Typography>
                        </Box>
                    </Box>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e5e7eb'}} />
                <DialogContent className='side' sx={{ p: 2.5 }}>
                    <Grid container spacing={2}>
                        {/* SECCIÓN: Reporte */}
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <AssessmentOutlinedIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 18 }} />
                                <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#1e293b', fontWeight: 600, fontSize: 13 }}>
                                    Reporte
                                </Typography>
                            </Box>
                            <SelectReportUser
                                dataArr={reporteArr}
                                value={reporteSelect}
                                onChange={(e)=>onSelectTipoReport(e)}
                            />
                        </Grid>

                        {/* SECCIÓN: Filtros de Fecha */}
                        <Grid item xs={12}>
                            <Card sx={{
                                background: isDarkMode ? '#2d3a52' : '#f8fafc',
                                border: `1px solid ${isDarkMode ? '#3d4a62' : '#e2e8f0'}`,
                                borderRadius: 3, p: 2, boxShadow: 'none',
                            }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <FilterAltOutlinedIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 18 }} />
                                        <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#1e293b', fontWeight: 600, fontSize: 13 }}>
                                            Filtros de Fechas
                                        </Typography>
                                    </Box>
                                    <ButtonBasic
                                        iconStart={<AddIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 18 }} />}
                                        textButton='Agregar'
                                        variant='wk'
                                        color='nextWhite'
                                        sx={{
                                            border: `1px solid ${isDarkMode ? '#3d4a62' : '#cbd5e1'}`,
                                            borderRadius: 2, fontSize: 12, height: 32,
                                            color: isDarkMode ? '#64B5F6' : '#0364ff',
                                            '&:hover': { background: isDarkMode ? '#3d4a62' : '#e2e8f0' }
                                        }}
                                        onClick={()=>onOpenModalRangoFecha()}
                                    />
                                </Box>
                                { rangoFechasArray?.length > 0 ? (
                                    <Grid container spacing={1}>
                                        {rangoFechasArray.map((rnfecha)=>(
                                            <Grid item xs={12} md={6} key={rnfecha?.keyCampo}>
                                                <Box sx={{
                                                    background: isDarkMode ? '#1F2A40' : '#fff',
                                                    border: `1px solid ${isDarkMode ? '#3d4a62' : '#e2e8f0'}`,
                                                    borderRadius: 2.5, p: 1.5,
                                                    display: 'flex', alignItems: 'center', gap: 1,
                                                    transition: 'all 0.2s',
                                                    '&:hover': { borderColor: isDarkMode ? '#64B5F6' : '#0364ff' }
                                                }}>
                                                    <CalendarMonthOutlinedIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 20 }} />
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#1e293b', fontWeight: 600, fontSize: 12, lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {rnfecha?.itemsCampo?.label}
                                                        </Typography>
                                                        <Typography sx={{ color: isDarkMode ? '#78909c' : '#64748b', fontSize: 11, lineHeight: 1.3 }}>
                                                            {FechaFunction.format(rnfecha?.fechaIni,'dd/MM/yyyy')} - {FechaFunction.format(rnfecha?.fechaFin,'dd/MM/yyyy')}
                                                        </Typography>
                                                    </Box>
                                                    <IconButton size="small" onClick={()=>onOpenModalDeleteValid(rnfecha?.keyCampo)}
                                                        sx={{ color: isDarkMode ? '#f87171' : '#ef4444', '&:hover': { background: isDarkMode ? '#3d2020' : '#fef2f2' } }}
                                                    >
                                                        <DeleteOutlineOutlinedIcon sx={{ fontSize: 18 }} />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ):(
                                    <Box sx={{
                                        background: isDarkMode ? '#1F2A40' : '#fff',
                                        border: `1px dashed ${isDarkMode ? '#3d4a62' : '#cbd5e1'}`,
                                        borderRadius: 2.5, py: 2.5,
                                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                                    }}>
                                        <Typography sx={{ color: isDarkMode ? '#546e7a' : '#94a3b8', fontSize: 13 }}>
                                            Sin filtros configurados
                                        </Typography>
                                    </Box>
                                )}
                            </Card>
                        </Grid>

                        {/* SECCIÓN: Programación */}
                        <Grid item xs={12}>
                            <Card sx={{
                                background: isDarkMode ? '#2d3a52' : '#f8fafc',
                                border: `1px solid ${isDarkMode ? '#3d4a62' : '#e2e8f0'}`,
                                borderRadius: 3, p: 2, boxShadow: 'none',
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                    <CalendarMonthOutlinedIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 18 }} />
                                    <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#1e293b', fontWeight: 600, fontSize: 13 }}>
                                        Programación
                                    </Typography>
                                </Box>

                                {/* Toggle tipo programación */}
                                <Box sx={{
                                    display: 'flex', gap: 0.5,
                                    background: isDarkMode ? '#1F2A40' : '#e2e8f0',
                                    p: 0.5, borderRadius: 2.5, mb: 2,
                                }}>
                                    <Box
                                        onClick={()=>onSelectTipoProg('DIA')}
                                        sx={{
                                            flex: 1, py: 0.8, textAlign: 'center', borderRadius: 2,
                                            cursor: 'pointer', transition: 'all 0.2s',
                                            fontWeight: 600, fontSize: 13,
                                            background: tipoPrograma === 'DIA' ? (isDarkMode ? '#0364ff' : '#0364ff') : 'transparent',
                                            color: tipoPrograma === 'DIA' ? '#fff' : (isDarkMode ? '#78909c' : '#64748b'),
                                            boxShadow: tipoPrograma === 'DIA' ? '0 2px 8px rgba(3, 100, 255, 0.3)' : 'none',
                                            '&:hover': { background: tipoPrograma === 'DIA' ? '#0364ff' : (isDarkMode ? '#3d4a62' : '#cbd5e1') }
                                        }}
                                    >
                                        Día de la semana
                                    </Box>
                                    <Box
                                        onClick={()=>onSelectTipoProg('NUMERO')}
                                        sx={{
                                            flex: 1, py: 0.8, textAlign: 'center', borderRadius: 2,
                                            cursor: 'pointer', transition: 'all 0.2s',
                                            fontWeight: 600, fontSize: 13,
                                            background: tipoPrograma === 'NUMERO' ? (isDarkMode ? '#0364ff' : '#0364ff') : 'transparent',
                                            color: tipoPrograma === 'NUMERO' ? '#fff' : (isDarkMode ? '#78909c' : '#64748b'),
                                            boxShadow: tipoPrograma === 'NUMERO' ? '0 2px 8px rgba(3, 100, 255, 0.3)' : 'none',
                                            '&:hover': { background: tipoPrograma === 'NUMERO' ? '#0364ff' : (isDarkMode ? '#3d4a62' : '#cbd5e1') }
                                        }}
                                    >
                                        Fecha del mes
                                    </Box>
                                </Box>

                                {tipoPrograma === 'NUMERO' ? (
                                    <Box>
                                        <Typography sx={{ color: isDarkMode ? '#90a4ae' : '#64748b', fontSize: 12, mb: 0.5 }}>
                                            Día del mes (1-28)
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            autoComplete='off'
                                            value={tipoProgramaData?.numero_lr || 1}
                                            onChange={(e)=>setTipoProgramaData({numero_lr: e.target.value})}
                                            sx={styleInput}
                                            type='number'
                                            inputProps={{ min: 1, max: 28, step: 1 }}
                                        />
                                    </Box>
                                ):(
                                    <Box sx={{ display: 'flex', gap: 0.75, justifyContent: 'center', flexWrap: 'wrap' }}>
                                        {dias.map((dia) => {
                                            const isActive = tipoProgramaData?.[dia.key];
                                            return (
                                                <Box
                                                    key={dia.key}
                                                    onClick={()=>setTipoProgramaData({ ...tipoProgramaData, [dia.key]: !tipoProgramaData?.[dia.key] })}
                                                    sx={{
                                                        width: 52, height: 52, borderRadius: '50%',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        cursor: 'pointer', transition: 'all 0.2s',
                                                        fontWeight: 600, fontSize: 13,
                                                        border: `2px solid ${isActive ? '#0364ff' : (isDarkMode ? '#3d4a62' : '#cbd5e1')}`,
                                                        background: isActive ? (isDarkMode ? '#0364ff' : '#0364ff') : (isDarkMode ? '#1F2A40' : '#fff'),
                                                        color: isActive ? '#fff' : (isDarkMode ? '#90a4ae' : '#64748b'),
                                                        boxShadow: isActive ? '0 2px 8px rgba(3, 100, 255, 0.3)' : 'none',
                                                        '&:hover': {
                                                            borderColor: '#0364ff',
                                                            transform: 'scale(1.08)',
                                                        }
                                                    }}
                                                >
                                                    {dia.label}
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                )}
                            </Card>
                        </Grid>

                        {/* SECCIÓN: Horario */}
                        <Grid item xs={12}>
                            <Card sx={{
                                background: isDarkMode ? '#2d3a52' : '#f8fafc',
                                border: `1px solid ${isDarkMode ? '#3d4a62' : '#e2e8f0'}`,
                                borderRadius: 3, p: 2, boxShadow: 'none',
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                    <AccessTimeOutlinedIcon sx={{ color: isDarkMode ? '#64B5F6' : '#0364ff', fontSize: 18 }} />
                                    <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#1e293b', fontWeight: 600, fontSize: 13 }}>
                                        Horario de ejecución
                                    </Typography>
                                </Box>
                                <Box sx={{ maxWidth: 180 }}>
                                    <TextField
                                        fullWidth
                                        autoComplete='off'
                                        sx={styleInput}
                                        value={tipoProgramTime}
                                        onChange={(e)=>setTipoProgramTime(e.target.value)}
                                        type='time'
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ step: 300 }}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e5e7eb'}} />
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', py: 1.5, gap: 1 }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        isDisabled={!rangoFechasArray || rangoFechasArray?.length === 0 || !reporteSelect}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalReporteProgramado